export default __webpack_public_path__ + "static/ssc-756538f5d007b74275b192da71bb9970.png";